import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import it from './locales/it.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import de from './locales/de.json';

// Extract language from URL path
const urlLang = window.location.pathname.split('/')[1];

// Supported languages
const supportedLngs = ['it', 'en', 'de', 'es', 'fr'];

// Check if the language from the URL is supported
const detectedLang = supportedLngs.includes(urlLang) ? urlLang : null;

i18n
    .use(LanguageDetector)
    .use(initReactI18next) // Passes i18n down to react-i18next
    .init({
        resources: {
            en: { translation: en },
            it: { translation: it },
            fr: { translation: fr },
            es: { translation: es },
            de: { translation: de }
        },
        supportedLngs: supportedLngs,
        detection: {
            order: ['querystring', 'localStorage', 'navigator'], // Add 'querystring' to check URL params
            caches: ['localStorage'],
            lookupLocalStorage: 'language',
            lookupQuerystring: 'lng', // Optional: Check for a query parameter like `?lng=en`
        },
        fallbackLng: 'it', // Fallback language if none detected
        interpolation: {
            escapeValue: false // React already does escaping
        }
    });

// Override the detected language if a valid language is found in the URL
if (detectedLang) {
    i18n.changeLanguage(detectedLang);
}

export const translate = (text) => {
    return i18n.t(text);
};

export const toggleLanguage = (lang) => {
    i18n.changeLanguage(lang);
};

export const lang = () => {
    return i18n.language;
};
export default i18n;